var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { staticClass: "dept-selector" },
    [
      _c("FancySelect", {
        attrs: {
          options: _vm.departmentOptions,
          "reset-after": _vm.resetAfter,
          value: _vm.currentValue,
          multiple: _vm.multiple,
          clearable: _vm.clearable,
          placeholder:
            _vm.placeholder ||
            (_vm.groupsOnly ? `Select department group` : `Select department`)
        },
        on: { input: _vm.onInput }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }